import React from 'react'
import { graphql } from 'gatsby'
import { Col, Container, Row } from '@headtrip/components-react'
import Layout from '../components/layout'

import './tutorialsBase.scss'
import { ArticleTags } from './communityArticles/Article'
import { Author } from '../components/Author/Author'
import { CommunityBreadcrumbs } from '../components/CommunityBreadcrumbs'
import SupplementSection from '../components/Various/SupplementSection/SupplementSection'
import TutorialLanguageDropdown from '../components/Tutorials/TutorialLanguageDropdown/TutorialLanguageDropdown'

import avatarPlaceholder from '../images/default_avatar.png'
// import iconAppSwitcher from '../images/app-switcher.svg'
// Header images
import defaultHeaderImage from '../images/community/tutorial-header-img.jpg'
import headerImg1 from '../images/header-images/hetzner_community_1.jpg'
import headerImg2 from '../images/header-images/hetzner_community_2.jpg'
import headerImg3 from '../images/header-images/hetzner_community_3.jpg'
import headerImg4 from '../images/header-images/hetzner_community_4.jpg'
import headerImg5 from '../images/header-images/hetzner_community_5.jpg'
import headerImg6 from '../images/header-images/hetzner_community_6.jpg'
import headerImg7 from '../images/header-images/hetzner_community_7.jpg'
import headerImg8 from '../images/header-images/hetzner_community_8.jpg'
import { TutorialOpenGraphTags } from './communityArticles/TutorialOpenGraphTags'
import { ShareSection } from './communityArticles/ShareSection/ShareSection'
import { GitHubButton } from './communityArticles/GitHubSection/GitHubButton'
import { MobileShareButton } from './communityArticles/ShareSection/MobileShareButton'
import TutorialCtaCard from '../components/CallToActions/TutorialCtaCard/TutorialCTACard'
import TutorialContributeCard from '../components/CallToActions/TutorialContributeCard/TutorialContributeCard'
import TutorialEndOfContentCta from '../components/CallToActions/TutorialEndOfContentCTA'
import { getCurrentCTA } from '../components/CallToActions/cta'
import SEO from '../components/seo'

export function TutorialContentArticle (props) {
  return (
    <div style={{ maxWidth: '800px', width: '100%' }}>
      <article
        className='tutorial-content'
        dangerouslySetInnerHTML={{ __html: props.html }}
      />
      <TutorialEndOfContentCta headerImg={props.frontmatter.header_img} />
      <GitHubButton
        frontmatter={props.frontmatter}
        className={'d-block d-lg-none mt-4'}
      />
    </div>
  )
}

export function TutorialContent (props) {
  let frontmatter = props.frontmatter
  const date = new Date(Date.parse(frontmatter.date + 'T00:00:00')).toDateString()
  const toc = props.toc
  const currentCTA = getCurrentCTA(frontmatter.cta)
  const hasPromoCode = typeof currentCTA.code !== 'undefined'

  return (
    <section>
      <SupplementSection color='light-grey' />
      <Container fluid>
        <Row className='row-margin-responsive'>
          <Col xl={3}>
            <div
              className='toc-md-gen hyphens-auto sticky-top d-none d-xl-block py-5'
            >
              <h6 className='text-gray-600'>
                Table of Contents
              </h6>
              <div dangerouslySetInnerHTML={{ __html: toc.replace(/href="[^#]*/g, 'href="') }} />
            </div>
          </Col>
          <Col xs={12} lg={9} xl={6} className='py-5 d-flex justify-content-center'>
            <TutorialContentArticle frontmatter={frontmatter} date={date} html={props.html} />
            {props.extend}
          </Col>
          <Col lg={3} xl={3}>
            <div className='sticky-top d-none d-lg-flex py-5 flex-column'>
              <div className="shadow-sm rounded" style={{ maxWidth: '400px' }}>
                <TutorialCtaCard cta={frontmatter.cta} headerImg={frontmatter.header_img} />
              </div>
              <div className='pt-4'>
                <TutorialContributeCard hasPromoCode={hasPromoCode} />
              </div>
              <div className='pt-4' style={{ maxWidth: 400 }}>
                <ShareSection frontmatter={frontmatter} />
                <GitHubButton frontmatter={frontmatter} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export function TutorialAuthor ({ avatar, name, authorImgClassName, profileURL }) {
  const githubProfileURL = profileURL || ''
  let avatarSrc = avatarPlaceholder

  if (avatarSrc !== '' || avatarSrc !== null) {
    avatarSrc = avatar
  }

  const author = (
    <>
      <Author
        name={name}
        src={avatarSrc}
        authorImgClassName='mx-auto mb-2 mb-lg-0'
        profileURL={githubProfileURL}
      />
    </>
  )

  if (githubProfileURL.length > 0) {
    return (
      <a
        href={githubProfileURL}
        className='link-unstyled'
        target='_blank'
      >
        {author}
      </a>
    )
  }

  return author
}

export function TutorialBaseHeader (props) {
  const authorDescription = props.frontmatter.author_description
  const headerStyle = getHeaderImage(props.frontmatter.header_img)

  return <section
    className={`tutorialentry--bg-img ${ headerStyle.gradient } text-shadow py-4 py-lg-6 d-block d-lg-flex align-items-lg-center`}
    style={{
      backgroundImage: 'url(' + headerStyle.image + ')',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left'
    }}
  >
    <Container>
      <Row>
        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
          <CommunityBreadcrumbs pathname='/tutorials/tutorial' />
        </Col>
      </Row>
      <Row className='mb-3 mb-lg-4'>
        <Col xl={9} lg={9} md={12} sm={12} xs={12}>
          <h1
            className='mb-0 text-center text-lg-left text-white text-shadow text-transform-none'
          >
            {props.frontmatter.title}
          </h1>
        </Col>
      </Row>
      <Row className='mb-3 mb-lg-4 text-center text-lg-left'>
        <Col className='d-block d-lg-flex justify-content-start align-items-center color-white'>
          <TutorialAuthor
            name={props.frontmatter.author}
            avatar={props.frontmatter.author_img}
            authorImgClassName='mx-auto mb-2 mb-lg-0'
            profileURL={props.frontmatter.author_link}
          />

          <div className='ml-lg-4'>
            <h6 className='d-none d-lg-block text-transform-none m-0'>Published</h6>
            <span>{props.frontmatter.date}</span>
          </div>
          <div className='ml-lg-4'>
            <h6 className='d-none d-lg-block text-transform-none m-0'>Time to read</h6>
            <span>{Math.ceil(props.markdownRemark.fields.readingTime.minutes)} minutes{' '}
              <span
                className='d-lg-none'
              >
              reading time
              </span>
            </span>
          </div>
          <div className='ml-lg-4'>
            {
              props.frontmatter.slug !== null && (
                <TutorialLanguageDropdown
                  currentLanguage={props.frontmatter.language}
                  availableLanguages={props.frontmatter.available_languages}
                  slug={props.frontmatter.slug}
                />
              )
            }
          </div>
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col xl={9} lg={9} md={12} sm={12} xs={12}>
          {
            authorDescription && (
              <p className='text-shadow text-white text-center text-lg-left hyphens-auto'>
                <strong>About the author-</strong> {authorDescription}
              </p>
            )
          }
        </Col>
      </Row>
      <div className='row text-center text-lg-left'>
        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
          <ArticleTags frontmatter={props.frontmatter} />
        </Col>
      </div>
    </Container>
  </section>
}

export default function Template ({
  data // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data // data.markdownRemark holds our post data
  const { frontmatter, html, headings } = markdownRemark

  /*

.breadcrumb-item a{
    padding: 5px 10px;
    background-color: hsla(0,0%,100%,.3);
  }
.breadcrumb-item + .breadcrumb-item::before {
    font-family: FontAwesome;
    content: "\F105";
    text-shadow: 0 0 5px #000;
    color: white;
  }
.badge-transparent {
    background-color: rgba(0,0,0,.35)
  }
.font-size-normal {
    font-size: 16px !important;
  }
*/

  return (
    <>
      <Layout noHeader location={{ pathname: frontmatter.path }}>
        <SEO {...frontmatter} type={'article'} locale={frontmatter.language} />
        <MobileShareButton frontmatter={frontmatter} />
        <main>
          <TutorialBaseHeader frontmatter={frontmatter} markdownRemark={markdownRemark} />
          <TutorialContent
            toc={markdownRemark.tableOfContents ? markdownRemark.tableOfContents : false}
            readingTime={markdownRemark.fields.readingTime}
            headings={headings}
            frontmatter={frontmatter}
            html={html}
          />
        </main>
      </Layout>
    </>
  )
}

/* export const renderImg = (imgURL) => {
  return <img src={imgURL} alt='' />
} */

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      tableOfContents (
          maxDepth: 2
      )
      headings {
        depth
        value
      }
      fields {
        slug
        readingTime {
          text
          minutes
          words
        }
      }
      frontmatter {
        cta  
        date
        path
        title
        short_description
        tags
        author_img
        author
        author_description
        author_link
        header_img
        available_languages
        slug
        language
        github_path
      }
    }
  }
`

export const renderAuthorDescription = descr => {
  return (<span dangerouslySetInnerHTML={{ __html: descr }} />)
}

export const getHeaderImage = headerName => {
  switch (headerName) {
  case 'header-1': {
    return {
      image: headerImg1, gradient: 'header-gradient-1'
    }
  }
  case 'header-2': {
    return {
      image: headerImg2, gradient: 'header-gradient-2'
    }
  }
  case 'header-3': {
    return {
      image: headerImg3, gradient: 'header-gradient-3'
    }
  }
  case 'header-4': {
    return {
      image: headerImg4, gradient: 'header-gradient-4'
    }
  }
  case 'header-5': {
    return {
      image: headerImg5, gradient: 'header-gradient-5'
    }
  }
  case 'header-6': {
    return {
      image: headerImg6, gradient: 'header-gradient-6'
    }
  }
  case 'header-7': {
    return {
      image: headerImg7, gradient: 'header-gradient-7'
    }
  }
  case 'header-8': {
    return {
      image: headerImg8, gradient: 'header-gradient-8'
    }
  }
  default: {
    return {
      image: defaultHeaderImage, gradient: 'header-gradient-default'
    }
  }
  }
}

export const getGradient = headerName => {
  switch (headerName) {
  case 'header-1': {
    return {
      smallBox: 'small-box-gradient-1',
      bigBox: 'big-box-gradient-1'
    }
  }
  case 'header-2': {
    return {
      smallBox: 'small-box-gradient-2',
      bigBox: 'big-box-gradient-2'
    }
  }
  case 'header-3': {
    return {
      smallBox: 'small-box-gradient-3',
      bigBox: 'big-box-gradient-3'
    }
  }
  case 'header-4': {
    return {
      smallBox: 'small-box-gradient-4',
      bigBox: 'big-box-gradient-4'
    }
  }
  case 'header-5': {
    return {
      smallBox: 'small-box-gradient-5',
      bigBox: 'big-box-gradient-5'
    }
  }
  case 'header-6': {
    return {
      smallBox: 'small-box-gradient-6',
      bigBox: 'big-box-gradient-6'
    }
  }
  case 'header-7': {
    return {
      smallBox: 'small-box-gradient-7',
      bigBox: 'big-box-gradient-7'
    }
  }
  case 'header-8': {
    return {
      smallBox: 'small-box-gradient-8',
      bigBox: 'big-box-gradient-8'
    }
  }
  default: {
    return {
      smallBox: 'small-box-gradient-default',
      bigBox: 'big-box-gradient-default'
    }
  }
  }
}
